import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DomainService} from '../../../services/domain.service';
import {AuthService} from '../../../services/auth.service';
import {NotificationService} from '../../../services/notification.service';
import {EnvironmentService} from '../../../services/environment.service';
import {LoadingPage} from '../../../../shared/components/loading/loading.page.component';
import {ModalSize, SmartModalService} from '../../../services/smart-modal.service';
import {CertificatePreviewComponent} from './preview/certificate-preview.component';
import {CertificateService} from './certificate.service';
import {Certificate, PreviewCertificate} from './certificate';

@Component({
  selector: 'itpx-certificate-tile',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.css']
})
export class CertificateTileComponent extends LoadingPage implements OnInit {
  @Input() learnerCertificate: any;
  @Input() type: string = 'participation';

  constructor(private router: Router,
              private domainService: DomainService,
              private authService: AuthService,
              private notificationService: NotificationService,
              private environmentService: EnvironmentService,
              private modalService: SmartModalService,
              private certificateService: CertificateService) {
    super();
  }

  ngOnInit() {
    this.ready();
  }

  previewCertificate() {
    switch(this.type){
      case 'participation':
        let certificate = new Certificate([this.learnerCertificate]);
        let previewCert = new PreviewCertificate(certificate);
        this.loading();
        this.certificateService.getCertificateHtml(previewCert) //Learner certificate id
          .map(body => body.data)
          .subscribe(data => {
            this.modalService.open(CertificatePreviewComponent, {text: data, previewCert:previewCert}, 'Certificate preview', ModalSize.Lg)
              .neverError()
              .subscribe();
            this.ready();
          }, err => {
            this.ready();
          });
        break;
      case 'completion':
        this.loading();
        this.certificateService.getElearningCertificateHtml(this.learnerCertificate.id) //Learner certificate id
          .map(body => body.data)
          .subscribe(data => {
            this.modalService.open(CertificatePreviewComponent,
              {
                text: data,
                id: this.learnerCertificate.id,
                eLearning: true
              }, 'E-Learning certificate preview', ModalSize.Lg)
              .neverError()
              .subscribe();
            this.ready();
          }, err => {
            this.ready();
          });
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/certificate/certificate.component.ts